module.exports = __webpack_public_path__ + "front/img/p22.a30a0fbf.png";